import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Tracker from '../utils/usageTracker';
import { RequestStatusPropType } from '../data/models/RequestStatus';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import ScopesAuthorization from 'developer-experience-shared-components/scopes/components/scopesAuthorization/ScopesAuthorization';
import SensitiveScopeGroupAlert from 'developer-experience-shared-components/scopes/components/scopesAuthorization/SensitiveScopeGroupAlert';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import UILink from 'UIComponents/link/UILink';
import HR from 'UIComponents/elements/HR';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIIcon from 'UIComponents/icon/UIIcon';
import Small from 'UIComponents/elements/Small';
import { LORAX } from 'HubStyleTokens/colors';
import H6 from 'UIComponents/elements/headings/H6';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { LISTING_STATUS } from '../data/models/ApplicationAuthorization';
import isEmbedded from '../utils/isEmbedded';
import AuthorizeFooter from './AuthorizeFooter';
import { EVENTS } from '../constants/Events';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class AuthorizeInfo extends Component {
  renderErrorAlert() {
    return /*#__PURE__*/_jsx(UIAlert, {
      className: "m-y-4",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "oauth.authorization.error.title"
      }),
      type: "danger",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "oauth.authorization.error.body"
      })
    });
  }
  renderTitle() {
    const {
      providerDomain,
      providerName,
      appId,
      authorizationData
    } = this.props;
    return /*#__PURE__*/_jsxs("span", {
      "data-test-id": "authorize-title",
      children: [/*#__PURE__*/_jsx("p", {
        className: "m-right-3 is--heading-2",
        children: /*#__PURE__*/_jsx("b", {
          children: /*#__PURE__*/_jsx(UITruncateString, {
            matchContentWidth: true,
            children: providerName
          })
        })
      }), providerDomain && /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: {
          Link: UILink
        },
        options: {
          domain: providerDomain,
          href: `https://${providerDomain}`,
          onClick: () => {
            Tracker.track(EVENTS.VERIFIED_DOMAIN_CLICK, {
              applicationId: appId,
              applicationName: providerName,
              domain: providerDomain
            });
          }
        },
        message: "oauth.authorization.appBy_jsx"
      }), authorizationData.getListingStatus() === LISTING_STATUS.CERTIFIED && /*#__PURE__*/_jsxs("div", {
        className: "p-top-3 display-flex",
        children: [/*#__PURE__*/_jsx(UIIcon, {
          size: 30,
          name: "hubspotCertification",
          color: LORAX
        }), /*#__PURE__*/_jsx(H6, {
          className: "display-inline m-y-0 p-left-1",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "oauth.app.certified"
          })
        })]
      })]
    });
  }
  render() {
    const {
      authorizationData,
      authorizeStatus
    } = this.props;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [authorizeStatus.failed && this.renderErrorAlert(), /*#__PURE__*/_jsxs(UITile, {
        className: "m-top-6",
        children: [/*#__PURE__*/_jsxs(UITileSection, {
          children: [this.renderTitle(), /*#__PURE__*/_jsx(HR, {}), authorizeStatus.succeeded && /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("b", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "developer-experience-shared-components.scopesAuthorization.appIsRequestingAccess"
              })
            }), /*#__PURE__*/_jsx(SensitiveScopeGroupAlert, {
              requestedScopes: authorizationData.scopeGroups
            }), /*#__PURE__*/_jsx(ScopesAuthorization, {
              requestedScopes: authorizationData.scopeGroups,
              className: "m-top-8",
              defaultOpenFirstScope: !isEmbedded
            })]
          })]
        }), /*#__PURE__*/_jsx(AuthorizeFooter, {})]
      }), /*#__PURE__*/_jsx("div", {
        className: "m-top-2",
        children: /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "oauth.authorization.recaptcha.protected_jsx",
            elements: {
              Link: UILink
            },
            options: {
              privacyHref: 'https://policies.google.com/privacy',
              tosHref: 'https://policies.google.com/terms'
            }
          })
        })
      })]
    });
  }
}
AuthorizeInfo.propTypes = {
  appId: PropTypes.number.isRequired,
  authorizationData: PropTypes.object,
  providerDomain: PropTypes.string,
  providerName: PropTypes.string.isRequired,
  authorizeStatus: RequestStatusPropType.isRequired
};
export default AuthorizeInfo;